module.exports = __webpack_public_path__ + "img/1.7f1e5315.png";